import { render, staticRenderFns } from "./cefloreco-banner-1.vue?vue&type=template&id=113f20ef&scoped=true&"
import script from "./cefloreco-banner-1.vue?vue&type=script&lang=js&"
export * from "./cefloreco-banner-1.vue?vue&type=script&lang=js&"
import style0 from "./cefloreco-banner-1.vue?vue&type=style&index=0&id=113f20ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f20ef",
  null
  
)

export default component.exports